import {
    ChartBarIcon,
    TreeStructureIcon,
    ShapesIcon,
    SlidersHorizontalIcon,
    TableIcon,
    SelectionAllIcon,
} from '@phosphor-icons/react'

export const mainToolbarItems = [
    {
        text: 'Summary',
        icon: ChartBarIcon,
        label: 'Chart/Table',
    },
    {
        text: 'Sheetlet',
        icon: TableIcon,
        label: 'Sheetlet',
    },
    {
        text: 'Process Diagram',
        icon: TreeStructureIcon,
        label: 'Process Diagram',
    },
    {
        text: 'Prompt',
        icon: SlidersHorizontalIcon,
        label: 'Prompt',
    },
    {
        text: 'Frame',
        icon: SelectionAllIcon,
        label: 'Frame',
    },
    {
        text: 'Objects',
        icon: ShapesIcon,
        label: 'Objects',
    },
]
